<ng-container [ngSwitch]="currentMenu">
  <ng-container *ngSwitchCase="screen.KIROKU">
    <ng-container *ngTemplateOutlet="kiroku"></ng-container>
  </ng-container>
</ng-container>
<ng-template #kiroku>
  <app-record-kids></app-record-kids>
</ng-template>